export default {
  account: () => import("E:/workspace/roncoo/roncoo-web/layouts/account.vue").then(m => m.default || m),
  activity: () => import("E:/workspace/roncoo/roncoo-web/layouts/activity.vue").then(m => m.default || m),
  buy: () => import("E:/workspace/roncoo/roncoo-web/layouts/buy.vue").then(m => m.default || m),
  course: () => import("E:/workspace/roncoo/roncoo-web/layouts/course.vue").then(m => m.default || m),
  default: () => import("E:/workspace/roncoo/roncoo-web/layouts/default.vue").then(m => m.default || m),
  exam: () => import("E:/workspace/roncoo/roncoo-web/layouts/exam.vue").then(m => m.default || m),
  practice: () => import("E:/workspace/roncoo/roncoo-web/layouts/practice.vue").then(m => m.default || m)
}